/*
 * PRESENTE SURPRESA — presentes caem / baloes sobem; clique = presente no carrinho; "Abrir" = roleta (sorteio no servidor).
 * Config e premios: snippets/surpresa-assets.liquid (window.LS_SURPRESA). Cupom sorteado vai ao checkout por LS_SURPRESA_APPLY.
 */
(function () {
  'use strict';
  var cfg = window.LS_SURPRESA;
  if (!cfg || !cfg.prizes || !cfg.prizes.length) return;
  // fora da janela da campanha (ex.: pagina em cache depois do fim) nao mostra nada
  if (!cfg.forcar && cfg.inicio && (Date.now() < cfg.inicio || Date.now() > cfg.fim)) return;

  var KEY = 'ls_surpresa_v1', TTL = 7 * 864e5, MIN = 29900; // MIN = presente a partir de R$299 (centavos)


  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- estado ---------------- */
  function load() {
    try {
      var s = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (s && Date.now() - (s.ts || 0) > TTL) { localStorage.removeItem(KEY); return null; }
      return s;
    } catch (_) { return null; }
  }
  function save(s) { s.ts = s.ts || Date.now(); try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (_) {} }
  var allPrizes = cfg.prizes.slice(); // o servidor pode devolver qualquer premio da lista; a roleta so mostra os disponiveis
  function prizeById(id) { for (var i = 0; i < allPrizes.length; i++) if (allPrizes[i].id === id) return allPrizes[i]; return null; }
  // identificador do aparelho (camada 1; o servidor cruza com IP e carrinho)
  function deviceId() {
    var k = 'ls_surpresa_dev', v = null;
    try { v = localStorage.getItem(k); } catch (_) {}
    if (!v) { var a = new Uint8Array(16); (window.crypto || {}).getRandomValues ? crypto.getRandomValues(a) : a.forEach(function (_, i) { a[i] = Math.random() * 256; });
      v = 'd' + Array.prototype.map.call(a, function (x) { return ('0' + x.toString(16)).slice(-2); }).join(''); try { localStorage.setItem(k, v); } catch (_) {} }
    return v;
  }
  // impressao do aparelho (tela, fuso, idioma, nucleos): igual em aba anonima e apos trocar de rede; so para o monitor de abuso agrupar sorteios
  function fingerprint() {
    var n = navigator, s = window.screen || {}, tz = '';
    try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (_) {}
    var raw = [n.userAgent, s.width + 'x' + s.height + '@' + (window.devicePixelRatio || 1), s.colorDepth, tz, (n.languages || [n.language]).join(','), n.hardwareConcurrency, n.deviceMemory, n.maxTouchPoints, n.platform].join('|');
    var h = 0x811c9dc5; for (var i = 0; i < raw.length; i++) { h ^= raw.charCodeAt(i); h = Math.imul(h, 0x01000193) >>> 0; }
    return ('0000000' + h.toString(16)).slice(-8);
  }
  // sorteio no SERVIDOR: o navegador so anima ate o premio devolvido
  function serverDraw() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).catch(function () { return {}; }).then(function (c) {
      return fetch(cfg.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ device_id: deviceId(), cart_token: (c && c.token) || '', fp: fingerprint(), test: !!cfg.test }) });
    }).then(function (r) {
      if (r.ok) return r.json();
      // recusa do servidor: guarda o motivo (limite da rede/aparelho = nao adianta tentar de novo)
      return r.json().catch(function () { return {}; }).then(function (j) { var e = new Error('recusado'); e.reason = (j && j.reason) || ''; e.status = r.status; throw e; });
    }).then(function (d) { if (!d || !d.ok || !d.prize) throw new Error('sem premio'); return d; });
  }
  var LIMITE = /^(limite_da_rede|rede_saturada|rate_limited)$/;
  function pickPrize() {
    var tot = 0, i; for (i = 0; i < cfg.prizes.length; i++) tot += Math.max(0, cfg.prizes[i].weight || 0);
    var r = Math.random() * tot;
    for (i = 0; i < cfg.prizes.length; i++) { r -= Math.max(0, cfg.prizes[i].weight || 0); if (r < 0) return cfg.prizes[i]; }
    return cfg.prizes[cfg.prizes.length - 1];
  }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------------- chuva de presentes / baloes ---------------- */
  var TEST = !!cfg.test; // modo teste: sorteio no servidor sem cupom real (preview antes do inicio). O ritmo da chuva e o mesmo do site.
  var layer = null, timer = 0, MAX_LIVE = 1; // um de cada vez (presente OU balao)
  /* RITMO (raro, vale para a sessao inteira, mudar de pagina nao recomeca a conta):
     1o presente entre 4 e 8 s de navegacao; depois um a cada 16-28 s; ja pegou (aberto ou nao): um a cada 24-40 s;
     sem limite por sessao (16/10 tarde; +15% e +10% em 16/10). Abriu o presente: continuam caindo, mas sem clique. */
  var RITMO = 'ls_surpresa_ritmo';
  function ritmo() { try { return JSON.parse(sessionStorage.getItem(RITMO)) || {}; } catch (_) { return {}; } }
  function salvaRitmo(r) { try { sessionStorage.setItem(RITMO, JSON.stringify(r)); } catch (_) {} }
  function rand(a, b) { return a + Math.random() * (b - a); }
  function podeChover() { return true; } /* abriu: segue chovendo, so que sem clique (aberto()) */
  function aberto() { return (load() || {}).status === 'opened'; }
  function inertes() { if (layer) Array.prototype.forEach.call(layer.children, function (b) { b.classList.add('is-inerte'); b.disabled = true; b.tabIndex = -1; b.setAttribute('aria-hidden', 'true'); }); }
  function drawerOpen() { var d = document.querySelector('cart-drawer'); return !!(d && d.hasAttribute('open')); }
  function blocked() {
    if (document.hidden || drawerOpen()) return true;
    if (/^\/(cart|checkout|account)/.test(location.pathname)) return true;
    return false;
  }
  function ensureLayer() {
    if (layer) return layer;
    layer = el('div', 'surpresa-layer'); layer.setAttribute('aria-hidden', 'false');
    document.body.appendChild(layer);
    return layer;
  }
  function spawn(kind) {
    if (blocked()) return;
    var L = ensureLayer();
    if (L.children.length >= MAX_LIVE) return;
    kind = kind || (Math.random() < .5 ? 'balloon' : 'gift');
    var b = el('button', 'surpresa-drop surpresa-drop--' + kind);
    b.type = 'button';
    b.setAttribute('aria-label', 'Pegar presente surpresa');
    b.innerHTML = '<img src="' + (kind === 'balloon' ? cfg.icons.balloon : cfg.icons.gift) + '" alt="" width="56" height="56" draggable="false">';
    var small = window.matchMedia('(max-width: 699px)').matches;
    var size = small ? 38 + Math.round(Math.random() * 8) : 46 + Math.round(Math.random() * 12);
    b.style.setProperty('--size', size + 'px');
    b.style.setProperty('--x', (6 + Math.random() * 82).toFixed(1) + 'vw');
    b.style.setProperty('--dur', (6.5 + Math.random() * 2.5).toFixed(1) + 's');
    b.style.setProperty('--sway', (Math.random() < .5 ? -1 : 1) * (10 + Math.random() * 18) + 'px');
    if (aberto()) { b.classList.add('is-inerte'); b.disabled = true; b.tabIndex = -1; b.setAttribute('aria-hidden', 'true'); }
    else b.addEventListener('click', function () { claim(b); });
    b.addEventListener('animationend', function (e) { if (e.target === b) b.remove(); });
    L.appendChild(b);
  }
  function agendar() {
    clearTimeout(timer);
    if (!podeChover()) return stopRain();
    var r = ritmo();
    var agora = Date.now();
    if (!r.next) { r.next = agora + rand(3900, 7900); salvaRitmo(r); }
    timer = setTimeout(tentar, Math.max(r.next - agora, rand(3000, 6000))); // pagina nova depois da hora: espera uns segundos
  }
  function tentar() {
    if (!podeChover()) return stopRain();
    if (blocked() || (layer && layer.children.length >= MAX_LIVE)) { timer = setTimeout(tentar, 4000); return; } // aba oculta, carrinho aberto...
    spawn();
    var r = ritmo(), pegou = !!(load() || {}).status;
    r.n = (r.n || 0) + 1; r.next = Date.now() + (pegou ? rand(23600, 39500) : rand(15800, 27600)); salvaRitmo(r);
    agendar();
  }
  function stopRain() { clearTimeout(timer); if (layer) { layer.remove(); layer = null; } }
  function startRain() {
    if (!podeChover()) return;
    if (reduce) { if ((load() || {}).status) return; // sem animacao: um presente parado no canto
      var L = ensureLayer(); L.classList.add('is-static');
      var b = el('button', 'surpresa-drop surpresa-drop--static');
      b.type = 'button'; b.setAttribute('aria-label', 'Pegar presente surpresa');
      b.innerHTML = '<img src="' + cfg.icons.gift + '" alt="" width="56" height="56">';
      b.addEventListener('click', function () { claim(b); });
      L.appendChild(b); return;
    }
    agendar();
  }

  function openDrawer() {
    var d = document.querySelector('cart-drawer');
    if (d && typeof d.show === 'function') d.show(); else if (d) d.setAttribute('open', '');
    refreshLines();
  }
  function claim(btn) {
    var st = load() || {};
    if (st.status === 'opened') return; // ja abriu: acabou
    if (btn && btn.dataset.claimed) return;
    if (btn) btn.dataset.claimed = '1';
    // ja tinha pego e nao abriu: nao cria outro, so mostra o que esta no carrinho
    if (st.status !== 'claimed') save({ status: 'claimed', mode: 'mini', ts: Date.now() }); // roleta compacta (do tamanho da linha do brinde)
    var isBalloon = btn && btn.classList.contains('surpresa-drop--balloon');
    function popGift() {
      if (btn) {
        btn.classList.add('is-popped');
      }
      setTimeout(function () { if (btn) btn.remove(); openDrawer(); }, reduce ? 0 : 350);
    }
    if (!isBalloon || reduce) return popGift();
    // balao estoura (confete + some transparente) e de dentro surge o presentinho, que depois abre igual ao presente
    var g = document.createElement('img'); g.className = 'surpresa-drop__inner'; g.src = cfg.icons.gift; g.alt = '';
    btn.appendChild(g);
    btn.classList.add('is-bursting');
    setTimeout(popGiftOnly, 300);
    function popGiftOnly() {
      setTimeout(function () { if (btn) btn.remove(); openDrawer(); }, 150);
    }
  }

  /* ---------------- linha no carrinho ---------------- */
  // Mesma estrutura do line-item do tema (midia 70/120px + line-item-info + caixa do seletor de quantidade),
  // sem a classe .line-item (o cart-kit-grouper mapeia .line-item por posicao contra cart.items).
  var lineCtx = {};
  function lineHTML(s, tc) {
    var media, title, sub, action;
    if (s.status === 'opened') {
      var p = prizeById(s.prize);
      if (!p) return '';
      media = p.type === 'cupom'
        ? '<span class="line-item__media surpresa-item__media"><img src="' + p.img + '" alt=""></span>'
        : '<img class="line-item__media surpresa-item__media surpresa-item__media--prize" src="' + p.img + '" alt="">';
      title = p.url ? '<a href="' + p.url + '" class="' + tc + '">' + esc(p.title) + '</a>' : '<p class="' + tc + '">' + esc(p.title) + '</p>';
      sub = '';
      var tot = +(lineCtx.total || 0), mn = +(lineCtx.min || 0);
      if (mn && tot < mn) { // abaixo de R$299 o cupom nao vale no checkout: o brinde fica "travado" ate voltar ao minimo
        var pc = Math.max(4, Math.min(100, Math.round(tot * 100 / mn)));
        var fl = ((mn - tot) / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        action = '<span class="quantity-selector quantity-selector--sm surpresa-item__box surpresa-item__lock" data-pct="' + pc + '" aria-label="Faltam ' + fl + ' para abrir"><span class="text-sm">+' + fl + ' para abrir</span></span>';
      } else action = '<span class="quantity-selector quantity-selector--sm surpresa-item__box"><span class="text-sm">Brinde</span></span>';
    } else {
      media = '<span class="line-item__media surpresa-item__media"><img src="' + cfg.icons.gift + '" alt=""></span>';
      title = '<p class="' + tc + '">Presente surpresa</p>';
      sub = '';
      var total = +(lineCtx.total || 0), min = +(lineCtx.min || 0);
      if (min && total < min) {
        // abaixo do minimo: botao "enche" conforme o carrinho chega a R$300 (de onde estava ate o valor atual)
        var pct = Math.max(4, Math.min(100, Math.round(total * 100 / min)));
        var falta = ((min - total) / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        action = '<span class="quantity-selector quantity-selector--sm surpresa-item__box surpresa-item__lock" data-pct="' + pct + '" aria-label="Faltam ' + falta + ' para abrir"><span class="text-sm">+' + falta + ' para abrir</span></span>';
      } else {
        action = '<button type="button" class="quantity-selector quantity-selector--sm surpresa-item__box surpresa-item__open" data-surpresa-open><span class="text-sm">Abrir</span></button>';
      }
    }
    return '<div class="surpresa-item">' + media +
      '<div class="line-item-info"><div class="v-stack justify-items-start gap-2">' +
        '<div class="v-stack justify-items-start gap-1">' + title + (sub ? '<p class="text-sm text-subdued">' + sub + '</p>' : '') + '</div>' +
        '<div class="h-stack gap-4">' + action + '</div>' +
      '</div></div></div>';
  }
  class SurpresaLine extends HTMLElement {
    connectedCallback() { this.render(); }
    render() {
      var s = load(), tot0 = Number(this.getAttribute('data-cart-total')) || 0;
      // carrinho >= R$299: o presente entra sozinho (sem precisar pegar balao) e o sorteio ja roda escondido no servidor;
      // a pessoa so precisa clicar em Abrir. Se nao abrir, o cupom do sorteio vai para o checkout do mesmo jeito (16/10).
      if ((!s || !s.status) && tot0 >= MIN) { s = { status: 'claimed', mode: 'mini', auto: true, ts: Date.now() }; save(s); }
      if (!s || !s.status) { this.hidden = true; this.innerHTML = ''; return; }
      if (!s.code && tot0 >= MIN) predraw();
      lineCtx = { total: this.getAttribute('data-cart-total'), min: this.getAttribute('data-min') };
      this.innerHTML = lineHTML(s, this.getAttribute('data-text-class') || '');
      var lock = this.querySelector('.surpresa-item__lock');
      if (lock) { // anima do ultimo progresso visto ate o atual
        var to = lock.getAttribute('data-pct'), from = sessionStorage.getItem('ls_surpresa_pct') || to;
        lock.style.setProperty('--p', from + '%');
        requestAnimationFrame(function () { requestAnimationFrame(function () { lock.style.setProperty('--p', to + '%'); }); });
        try { sessionStorage.setItem('ls_surpresa_pct', to); } catch (_) {}
      } else { try { sessionStorage.setItem('ls_surpresa_pct', '100'); } catch (_) {} }
      this.hidden = !this.innerHTML;
      if (s.code) prepare(Number(lineCtx.total) || 0); // cupom brinde + R$50 pronto antes do checkout
      var b = this.querySelector('[data-surpresa-open]');
      if (b) b.addEventListener('click', function (e) { var ct = e.currentTarget; ready.then(function () { openRoulette({ currentTarget: ct }); }); });
    }
  }
  if (!customElements.get('ls-surpresa-line')) customElements.define('ls-surpresa-line', SurpresaLine);
  function refreshLines() { document.querySelectorAll('ls-surpresa-line').forEach(function (n) { n.render(); }); }

  /* ---------------- roleta (dentro da propria linha do carrinho) ----------------
     Fica no carrinho de proposito: um modal por cima faz o tema fechar a gaveta (clique "fora" dela). */
  /* Abrir: a roleta ja comeca a girar no clique (sem "Abrindo..."); o servidor sorteia em paralelo e a roleta
     desacelera ate o premio. Falha do servidor em producao: para e mostra "Tente de novo" (nunca sorteia no navegador). */
  function openRoulette(e) {
    var line = e && e.currentTarget && e.currentTarget.closest('ls-surpresa-line');
    var s = load();
    if (!line || !s || s.status !== 'claimed' || line.dataset.girando) return;
    line.dataset.girando = '1';
    var reel = startReel(line);
    // ja sorteado escondido (carrinho >= R$299): a roleta para no premio guardado, sem novo sorteio
    (predrawing || Promise.resolve()).then(function () { var c = load(); return c && c.code && c.prize ? { ok: true, prize: c.prize, code: c.code, code50: c.code50 || '' } : serverDraw(); }).then(function (d) {
      var prize = prizeById(d.prize); if (!prize) throw new Error('premio desconhecido');
      save({ status: 'opened', prize: prize.id, code: d.code, code50: d.code50 || '', ts: s.ts }); // salvo antes de parar: reabrir nao sorteia de novo
      inertes(); // abriu: os presentes seguem caindo, sem clique
      reel.land(prize);
    }).catch(function (err) {
      if (err && LIMITE.test(err.reason || '')) { // passou do limite de presentes desta rede/aparelho: avisa e nao deixa tentar de novo
        reel.cancel();
        var bl = line.querySelector('[data-surpresa-open]'); if (bl) { bl.disabled = true; bl.classList.add('is-limite'); bl.querySelector('span').textContent = 'Limite atingido'; }
        return;
      }
      if (cfg.test && cfg.prizes[0] && cfg.prizes[0].weight != null) { // so no modo teste: sorteio local se o servidor estiver fora
        var p = pickPrize(); save({ status: 'opened', prize: p.id, code: 'TESTE-LOCAL', ts: s.ts }); inertes(); return reel.land(p);
      }
      reel.cancel();
      var b = line.querySelector('[data-surpresa-open]'); if (b) { b.disabled = false; b.querySelector('span').textContent = 'Tente de novo'; }
    });
  }

  /* ---------------- sorteio na propria foto ----------------
     Todas as fotos ficam empilhadas e pre-carregadas; o giro so troca qual esta visivel (sem baixar imagem no meio = sem travada). */
  var preloaded = false;
  function preloadImgs() { cfg.prizes.forEach(function (p) { if (!p.img) return; var im = new Image(); im.decoding = 'async'; im.src = p.img; }); }
  // produtos: foto e disponibilidade vem de /products/<handle>.js; sem estoque ou sem foto sai da roleta
  var ready = Promise.all(cfg.prizes.map(function (p) {
    if (p.type !== 'produto') return null;
    return fetch(p.url + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
      if (!d || !d.available || !d.featured_image) { p.off = true; return; }
      var u = d.featured_image; u = (u.indexOf('//') === 0 ? 'https:' : '') + u;
      p.img = u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=300';
    }).catch(function () { p.off = true; });
  })).then(function () { cfg.prizes = cfg.prizes.filter(function (p) { return !p.off && p.img; }); preloadImgs(); refreshLines(); });
  function preload() { if (preloaded) return; preloaded = true; }
  // Roleta compacta (do tamanho da linha do brinde). Faixa periodica (as fotos se repetem a cada volta), entao o giro e
  // continuo e sem emenda. Ao saber o premio: segue girando ate o ponto certo e desacelera (ease-out de 5a potencia, que
  // comeca exatamente na velocidade do giro e termina parando devagar). Sem mask-image (pisca no mobile); translate3d.
  function startReel(line) {
    var media = line.querySelector('.surpresa-item__media');
    var size = media ? media.getBoundingClientRect().width : 70, width = line.clientWidth || 320, gap = 8, step = size + gap;
    var pool = cfg.prizes.length ? cfg.prizes : allPrizes, n = pool.length, reps = 7, tiles = [], i;
    for (i = 0; i < n * reps; i++) tiles.push(pool[i % n]);
    var box = document.createElement('div');
    box.className = 'surpresa-mini'; box.style.setProperty('--tile', size + 'px');
    box.innerHTML = '<span class="surpresa-mini__marker" aria-hidden="true"></span><div class="surpresa-mini__track">' +
      tiles.map(function (t, k) { return '<span class="surpresa-mini__tile' + (t.type === 'cupom' ? ' is-emoji' : '') + '" data-k="' + k + '"><img src="' + t.img + '" alt="" decoding="sync"></span>'; }).join('') + '</div>';
    var track = box.querySelector('.surpresa-mini__track');
    var center = width / 2 - size / 2, repW = n * step;
    var v = repW / 1300;            // velocidade do giro: uma volta a cada 1,3 s (px/ms)
    var T_PARADA = 3800;            // duracao da desaceleracao
    var DIST = v * T_PARADA / 5;    // distancia da parada (com ease-out^5 a velocidade inicial = 5*DIST/T = v)
    var x = center - repW * 0.5, last = 0, raf = 0, alvo = null, parada = null, fim = false, guarda = 0;
    function put() { track.style.transform = 'translate3d(' + x.toFixed(2) + 'px,0,0)'; }
    function frame(ts) {
      if (fim) return;
      if (!line.isConnected) { fim = true; return refreshLines(); }
      if (!last) last = ts;
      var dt = Math.min(ts - last, 40); last = ts;
      if (!parada) {
        x -= v * dt;
        if (alvo) { if (x - alvo.stop <= DIST) parada = { t0: ts, x0: x, D: x - alvo.stop, T: (x - alvo.stop) * 5 / v }; }
        else if (x < center - repW * 2) x += repW; // volta sem emenda
      }
      if (parada) {
        var u = Math.min((ts - parada.t0) / parada.T, 1);
        x = parada.x0 - parada.D * (1 - Math.pow(1 - u, 5));
        if (u >= 1) { put(); return done(); }
      }
      put();
      raf = requestAnimationFrame(frame);
    }
    function done() {
      if (fim) return; fim = true; cancelAnimationFrame(raf); clearTimeout(guarda);
      if (!line.isConnected) return refreshLines();
      x = alvo.stop; put();
      var w = box.querySelector('[data-k="' + alvo.k + '"]'); if (w) w.classList.add('is-win');
      if (window.LSConfetti && !reduce) { var r = box.getBoundingClientRect(); window.LSConfetti.burst({ x: r.left + r.width / 2, y: r.top + r.height / 2, count: 70, spread: Math.PI * 2, power: .9 }); }
      setTimeout(function () { delete line.dataset.girando; line.render(); }, reduce ? 0 : 1200);
    }
    put();
    line.replaceChildren(box); // fotos ja carregadas no inicio da pagina (preloadImgs): comeca na hora
    if (!reduce) raf = requestAnimationFrame(frame);
    return {
      land: function (prize) {
        if (fim || alvo) return;
        var idx = -1, k; for (k = 0; k < n; k++) if (pool[k].id === prize.id) { idx = k; break; }
        // 1o tile do premio que ainda esta a pelo menos DIST de distancia (tile k no centro quando x = center - k*step)
        var k0 = Math.ceil((center - x + DIST) / step);
        var kAlvo = idx >= 0 ? k0 + (((idx - k0) % n) + n) % n : k0;
        if (idx < 0) { var im = track.children[kAlvo] && track.children[kAlvo].querySelector('img'); if (im) im.src = prize.img; } // premio fora da faixa (sem estoque na vitrine)
        alvo = { k: kAlvo, stop: center - kAlvo * step };
        guarda = setTimeout(done, 1300 + T_PARADA + 2500); // aba em segundo plano segura os quadros
        if (reduce || document.hidden) done();
      },
      cancel: function () { fim = true; cancelAnimationFrame(raf); delete line.dataset.girando; if (line.isConnected) line.render(); }
    };
  }

  /* cupom sorteado entra sozinho no checkout (Yampi ?promocode=; a Yampi aceita 1 cupom por compra).
     Roda ANTES do aniversario. Carrinho >= minimo do aniversario (R$499): cupom combinado do mesmo sorteio (SURP-XXXX-50 =
     brinde + R$50, acumula com o frete gratis); abaixo disso: SURP-XXXX (so o brinde). Sem presente aberto: o ANIVERSARIO50 segue. */
  /* sorteio escondido: 1 por vez por aparelho; falhou (inclusive limite) = silencio, espera 60 s e a linha segue em "Abrir" */
  var predrawing = null, predrawFalhou = 0;
  function predraw() {
    var s0 = load();
    if (s0 && s0.code) return Promise.resolve();
    if (predrawing) return predrawing;
    if (predrawFalhou && Date.now() - predrawFalhou < 60000) return Promise.resolve();
    predrawing = serverDraw().then(function (d) {
      var cur = load() || {};
      if (cur.code) return; // abriu a roleta enquanto isso
      var p = prizeById(d.prize); if (!p) throw new Error('premio desconhecido');
      cur.status = cur.status || 'claimed'; cur.mode = cur.mode || 'mini'; cur.prize = p.id; cur.code = d.code; cur.code50 = d.code50 || '';
      save(cur);
    }).catch(function () { predrawFalhou = Date.now(); }).then(function () { predrawing = null; });
    return predrawing;
  }
  var prepping = null, prepTotal = -1, prepFalhou = {}; // falhou para este total: espera 60 s (nao estoura o limite de 6/min do servidor)
  function prepare(totalCents) {
    var s = load();
    if (!cfg.min50 || !s || !s.code || /^TESTE/.test(s.code) || s.code50 || totalCents < cfg.min50) return Promise.resolve();
    if (prepping && prepTotal === totalCents) return prepping;
    if (prepFalhou[totalCents] && Date.now() - prepFalhou[totalCents] < 60000) return Promise.resolve();
    prepTotal = totalCents;
    prepping = fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).catch(function () { return {}; }).then(function (c) {
      return fetch(cfg.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ device_id: deviceId(), cart_token: (c && c.token) || '', fp: fingerprint(), upgrade: true }) });
    }).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
      var cur = load();
      if (d && d.ok && d.code50 && cur && cur.code === d.code) { cur.code50 = d.code50; save(cur); } else prepFalhou[totalCents] = Date.now();
    }).catch(function () { prepFalhou[totalCents] = Date.now(); }).then(function () { prepping = null; });
    return prepping;
  }
  // chamado pelo redirecionamento do checkout: espera o cupom combinado no maximo 3 s (sem ele vai o cupom do brinde)
  // Carrinho >= R$299 sem cupom de sorteio (nao pegou/nao abriu o presente): sorteia no servidor agora, espera ate 6 s.
  window.LS_SURPRESA_PREPARE = function (totalCents) {
    var t = typeof totalCents === 'number' ? totalCents : 0, s = load(), precisa = t >= MIN && !(s && s.code);
    if (precisa && !(s && s.status)) save({ status: 'claimed', mode: 'mini', auto: true, ts: Date.now() });
    if (precisa) predrawFalhou = 0; // no checkout tenta de novo mesmo se o sorteio escondido falhou antes
    var job = (precisa ? predraw() : Promise.resolve()).then(function () { return prepare(t); });
    return Promise.race([job, new Promise(function (r) { setTimeout(r, precisa ? 6000 : 3000); })]);
  };
  window.LS_SURPRESA_APPLY = function (url, totalCents) {
    // cupom unico do sorteio liga a regra de brinde na Yampi; cupom de teste nunca vai ao checkout
    var s = load();
    if (!s || !s.code || /^TESTE/.test(s.code) || typeof url !== 'string' || /[?&]promocode=/.test(url)) return url;
    if (typeof totalCents === 'number' && totalCents < MIN) return url; // abaixo de R$299 o cupom nao vale: deixa o frete gratis entrar
    var code = (cfg.min50 && s.code50 && typeof totalCents === 'number' && totalCents >= cfg.min50) ? s.code50 : s.code;
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'promocode=' + encodeURIComponent(code);
  };

  /* ---------------- inicio ---------------- */
  window.LS_SURPRESA.reset = function () { try { localStorage.removeItem(KEY); } catch (_) {} refreshLines(); }; // teste
  window.LS_SURPRESA.spawn = spawn; // teste
  function init() {
    // preview (tema draft com "forcar"): ?surpresa_reset=1 zera presente e ritmo para testar de novo do zero
    if (cfg.forcar && /[?&]surpresa_reset=1/.test(location.search)) { try { localStorage.removeItem(KEY); sessionStorage.removeItem(RITMO); sessionStorage.removeItem('ls_surpresa_pct'); } catch (_) {} }
    refreshLines();
    preload();
    startRain();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
